import { createContext } from "react";

import { DischargeHelper } from "./DischargeHelper.ts";

export const DischargeContext = createContext<DischargeHelper>(
  {} as DischargeHelper
);
